import {
  storeAuditAnalytics,
  storeAuditService,
} from 'features/order/store-audit/infra';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import appStore from 'redux/stores/app.store';

import type { OrderDetailStateRedux } from 'shared/infra/redux';

export function useOrderProductsByCorridor({ orderId }: Props) {
  const { products = [] } = appStore.getOrderDetailInOrderDetailDialog() ?? {};

  const _orderAudit = storeAuditService.getOrderAudit(orderId);

  const _currentOrder = useSelector<any, OrderDetailStateRedux[]>(
    (state: any) => state.ordersReducer.orders,
  ).find(x => x.id === orderId);

  const [sortedProducts, setSortedProducts] = useState<any>(() =>
    [...products]
      .sort(
        (a, b) =>
          (b.has_defect_rate_report ? 1 : 0) -
          (a.has_defect_rate_report ? 1 : 0),
      )
      .map(product => ({
        ...product,
        isDefectChecked: _orderAudit?.isAllChecked,
      })),
  );

  function _logAnalytic() {
    const storeId = _currentOrder?.store_id ?? 0;
    const isMandatory =
      _currentOrder?.detail?.qr_information?.is_mandatory ?? false;

    storeAuditAnalytics.log({
      orderId,
      storeId,
      isMandatory,
      allChecked: true,
    });
  }

  function handleCheckDefectProduct(orderProductId: number) {
    const products = sortedProducts.map(product => ({
      ...product,
      isDefectChecked:
        product.order_product_id === orderProductId
          ? !product.isDefectChecked
          : product.isDefectChecked,
    }));
    setSortedProducts(products);
    validateAllDefectedProducstAreChecked({ products });
  }

  function validateAllDefectedProducstAreChecked({ products }) {
    const { defectCount, checkedCount } = products.reduce(
      (acc, product) => {
        if (product.has_defect_rate_report) {
          acc.defectCount++;
          if (product.isDefectChecked) acc.checkedCount++;
        }
        return acc;
      },
      { defectCount: 0, checkedCount: 0 },
    );

    const isAllProductsChecked = defectCount === checkedCount;

    if (isAllProductsChecked) {
      _logAnalytic();
    }

    storeAuditService.addCheckedOrder(orderId, isAllProductsChecked);
  }

  return {
    sortedProducts,
    handleCheckDefectProduct,
    isDefectProductsChecked: _orderAudit?.isAllChecked,
  };
}

interface Props {
  orderId: number;
}
